import styles from './index.module.less'
import IconFont from '@/utils/IconFont'
import { Avatar, Badge, Button, Dropdown, Menu, message, Select, Spin ,Image, Modal, Input, Form ,Tooltip} from 'antd'
import { LockOutlined } from '@ant-design/icons';
import { Link, request, useAuth, useHistory,useLocation  } from "ice";
import localStore from 'store';
import store from '@/store';
import { useEffect, useState } from "react";
import _ from 'lodash';
import debounce from 'lodash/debounce';
import { rsaEncodeByPublicKey } from "@/utils";

const { Option } = Select;

// 首页搜索课程和讲师
const searchData = async (params?) => {
  return await request.get(`/api-training-center-system/v1/search/course/lecturer/data`, { params })
}
// 更新个人消息状态
const msgStatistics = async (params?) => {
  return await request.get(`/api-training-center-member/v1/person/wechat/msg/statistics`,params)
}
// 获取头像
export const getHeadImg = async () => {
  return await request.post(`/api-node/sysuser/querymenu`)
}
// 退出登录
export const loginOut = async (params) => {
  return await request.post('/api-uaa/oauth/remove/token', params)
}
// 修改密码
const resetSysuserPassword = async (params) => {
  return await request.post(`/api-node/sysuser/resetSysuserPassword`, params);
};

const CommonHead = ({hasBottom = true, link = '/dashboard'}) => {
  const history = useHistory()
  const locationRou = useLocation();
  const employeeInfo = localStore.get('employeeInfo')
  const isLecturer = localStore.get('isLecturer')
  const [auth, setAuth] = useAuth();
  const [userState, userDispatchers] = store.useModel('user')
  //总条数
  const [total, setTotal] = useState<number>(0)
  //搜索字段
  const [keywords , setKeywords ] = useState<string>()
  //是否加载
  const [isLoading , setIsLoading] = useState<boolean>(false)
  //搜索的结果
  const [dataList, setDataList] = useState<Array<object>>([]);
  const [forgetModalVisible, setForgetModalVisible] = useState<boolean>(false);

  const [menuList, setMenuList] = useState([
    { title: '首页', icon: 'icon-menudashboard', link: '/' },
    { title: '课程库', icon: 'icon-tiku', link: '/course' },
    { title: '讲师库', icon: 'icon-chengyuan', link: '/lecture' },
    { title: '社区', icon: 'icon-biaoqian', link: '/faq' },
  ]);

  const switchUser = () => {
    history.replace(`${auth.lecturer ? '/' : '/lectureHome'}`)
    if (auth.lecturer){
      setMenuList([
        { title: '首页', icon: 'icon-menudashboard', link: '/' },
        { title: '课程库', icon: 'icon-tiku', link: '/course' },
        { title: '讲师库', icon: 'icon-chengyuan', link: '/lecture' },
        { title: '社区', icon: 'icon-biaoqian', link: '/faq' },
      ])
    }else{
      setMenuList([
        { title: '首页', icon: 'icon-menudashboard', link:  '/lectureHome' },
        { title: '课程库', icon: 'icon-tiku', link: '/course' },
        { title: '讲师库', icon: 'icon-chengyuan', link: '/lecture' },
        { title: '社区', icon: 'icon-biaoqian', link: '/faq' },
        { title: '培训区', icon: 'icon-biaoqian', link: '/trainingBay' }
      ])
    }

    setAuth({
      lecturer: !auth.lecturer,
    })
  }

  const exit = async () => {
    message.loading({ content: '正在退出', key: 'loginOut' })
    await loginOut({})
    localStore.clearAll()
    message.success({ content: '退出成功', key: 'loginOut', duration: 2 })
    window.location.href = '/login';
  }

  useEffect(() => {
    // getPersonMsg()
    getHeadImgApi()
    getMsgStatistics()

    if(locationRou.pathname=='/'){
      setAuth({
        lecturer: false
      })
      setMenuList([
        { title: '首页', icon: 'icon-menudashboard', link: '/' },
        { title: '课程库', icon: 'icon-tiku', link: '/course' },
        { title: '讲师库', icon: 'icon-chengyuan', link: '/lecture' },
        { title: '社区', icon: 'icon-biaoqian', link: '/faq' },
      ])
    }else if(locationRou.pathname=='/lectureHome'){
      setAuth({
        lecturer: true
      })
      setMenuList([
        { title: '首页', icon: 'icon-menudashboard', link:  '/lectureHome' },
        { title: '课程库', icon: 'icon-tiku', link: '/course' },
        { title: '讲师库', icon: 'icon-chengyuan', link: '/lecture' },
        { title: '社区', icon: 'icon-biaoqian', link: '/faq' },
        { title: '培训区', icon: 'icon-biaoqian', link: '/trainingBay' }
      ])
    }
  }, []);
  //获取个人消息数
  const getMsgStatistics = async () => {
    const res = await msgStatistics({});
    setTotal(res.datas?.unRead)
  };

  //选中搜索的回调
  const handleSelect =value=>{
    history.push('/courseDetail?id='+ value);
  }
  //搜索的回调
  const handleSearch =async value=>{
    setIsLoading(true)
    getData(value)
    setIsLoading(false)
  }
  const getData = debounce(async(params)=>{
    const res = await searchData({
      keywords: params
    })
    setDataList(res.datas.courses)
  },300)

  //跳转我的消息
  const toMyMessage = ()=>{
    if(!auth.lecturer){
      history.push('/studentUser?type='+ 'MyMessage');
    }else{
      history.push('/user?type='+ 'MyMessage');
    }
  }

   // 获取头像接口
   const getHeadImgApi = async () => {
    // const res = await getHeadImg()
    userDispatchers.update({
      headImage:'http://dfs.sunwoda.com/swdTrainingCenter/20220809/16/45/8/de66579a86d373b17df4422b1229d0df.jpg'
    })
  }

  // 修改密码
  const changePassword = async (values) => {
    const res = await resetSysuserPassword({
      oldPassword: rsaEncodeByPublicKey(values.oldPassword, localStore.get('rsaPubKey')),
      newPassword: rsaEncodeByPublicKey(values.newPassword, localStore.get('rsaPubKey')),
      confirmNewPassword: rsaEncodeByPublicKey(values.confirmNewPassword, localStore.get('rsaPubKey')),
    })
    if (res['resp_code'] == 200) {
      Modal.success({
        title: '密码修改成功',
        content: '下次登录请使用新密码进行登录',
        onOk() {
          setForgetModalVisible(false)
        }
      })
    }
  }

  const toEdit = () => {
    window.open('https://dios-imp.dianliantech.com/user/forgetPassword')
  }


  return (
    <div className={styles.commonHead}>
      <div className={styles.commonHeadLeft}>
        <Link to={auth.lecturer ? '/lectureHome' : '/'} className={styles.commonHeadTitle}>数字化学习运营管理平台</Link>
        <div className={styles.commonHeadMenu}>
          <Link
            x-for={(item, i) in menuList} key={i} to={item.link}
            className={`${styles.menuItem}${item.link == link ? ` ${styles.active}` : ''}`}
          >
            <IconFont type={item.icon} className={styles.iconItem}/>
            <div>{item.title}</div>
          </Link>
        </div>
      </div>
      <div className={styles.commonHeadRight}>
        <div className={styles.commonSearch}>
          <Select
            allowClear
            value={keywords}
            showSearch   //提供输入搜索功能
            placeholder="请输入课程"
            filterOption={false}    //关闭自动筛选
            optionFilterProp="label"
            defaultActiveFirstOption={false}
            notFoundContent={isLoading ? <Spin size="small"/> : null}
            onSearch={handleSearch}
            onSelect={handleSelect}
            bordered={false}
            style={{
              width: 249
            }}>
            {
              dataList.map((item:any, index) => (
              <Option key={item.id} value={item.startCourseId}>{item.startCourseTheme}</Option>
                ))
            }
          </Select>
        </div>
        <Button x-if={isLecturer} onClick={switchUser} type="primary" className={styles.commonBtn}>切换到{auth.lecturer ? '用户' : '讲师'}端</Button>
        <Badge  color="#FF6B00" className={styles.headIcon} count={total}>
          <IconFont type="icon-tixing" style={ {color: '#9495A8', fontSize: '16px'} } onClick={toMyMessage} />
        </Badge>

        <Tooltip  title={_.get(employeeInfo, 'orgFullName', '')}>
         <Avatar size={28} src={<Image src={userState.headImage} preview={false} />} shape="circle" />
        </Tooltip>
        <Dropdown overlay={
          <Menu>
            <Menu.Item key="1" onClick={() => { history.push(`${auth.lecturer ? '/user' : '/studentUser'}`) }}>个人中心</Menu.Item>
            {/* <Menu.Item key="2" onClick={() => {setForgetModalVisible(true)}}>修改密码</Menu.Item> */}
            <Menu.Item onClick={toEdit} key="2">修改密码</Menu.Item>
            <Menu.Item key="3" onClick={exit}>退出</Menu.Item>
          </Menu>
        } placement="bottomRight">
          <div className={styles.headdropDown}>
            <div className={styles.username}>{_.get(employeeInfo, 'employeeName', '')}</div>
            <IconFont type="icon-fold" style={{color: '#9495A8'}}/>
          </div>
        </Dropdown>
      </div>

      <Modal title="修改密码" width="400px" visible={forgetModalVisible} footer={null} onCancel={() => {setForgetModalVisible(false)}} maskClosable={false} destroyOnClose={true}>
        <Form size="large" onFinish={changePassword}>
          <Form.Item name="oldPassword" rules={[{ required: true, message: '请输入原密码' }, { type: 'string', min: 6, message: '密码长度不小于6位' }]}>
            <Input.Password placeholder="请输入原密码" prefix={<LockOutlined style={{color: '#6266EA', marginRight: 4}} />} />
          </Form.Item>
          <Form.Item name="newPassword" hasFeedback rules={[{ required: true, message: '请输入新密码' }, { type: 'string', min: 6, message: '密码长度不小于6位' }]}>
            <Input.Password placeholder="请输入新密码" prefix={<LockOutlined style={{color: '#6266EA', marginRight: 4}} />} />
          </Form.Item>
          <Form.Item
            name="confirmNewPassword"
            dependencies={['newPassword']}
            hasFeedback
            rules={[
              { required: true, message: '请再次输入新密码' },
              { type: 'string', min: 6, message: '密码长度不小于6位' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的新密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="请再次输入新密码" prefix={<LockOutlined style={{color: '#6266EA', marginRight: 4}} />} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{width: '100%'}}>保存</Button>
          </Form.Item>
        </Form>
      </Modal>

    </div>
  )
}

export default CommonHead
